import { Injectable } from "@angular/core";
import { UserProvider } from "../../providers/user/user";
import { CadastroModel } from "./cadastro.modelview";
import { Observable } from "rxjs/Observable";
import { ListasProvider } from "../../providers/listas/listas";
import { MediaProvider } from "../../providers/media/media";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class CadastroPageProvider {

    constructor(
        public userProvider: UserProvider,
        public listsProvider: ListasProvider,
        public mediaProvider: MediaProvider,
        public sanitizen: DomSanitizer
    ) { }

    registerUser(cadastroModel: CadastroModel): Observable<any> {

        return Observable.create(observer => {
            this.userProvider.registerUser(
                cadastroModel.nome,
                cadastroModel.estado,
                cadastroModel.crm,
                cadastroModel.especialidade,
                cadastroModel.interesse,
                cadastroModel.endereco,
                cadastroModel.telefone,
                cadastroModel.email,
                cadastroModel.senha,
                cadastroModel.opcao_contato,
                cadastroModel.foto
            ).subscribe(() => {
                observer.next("register Sucess")
            }, err => {
                observer.error(err)
            })
        })
    }

    editUser(userId: string, cadastroModel: CadastroModel): Observable<any> {
        return Observable.create(observer => {
            this.userProvider.updateUserData(
                userId,
                cadastroModel.nome,
                cadastroModel.estado,
                cadastroModel.crm,
                cadastroModel.especialidade,
                cadastroModel.interesse,
                cadastroModel.endereco,
                cadastroModel.telefone,
                cadastroModel.email,
                cadastroModel.senha,
                cadastroModel.opcao_contato,
                cadastroModel.foto
            ).subscribe(() => {
                observer.next("Edited Sucess")
            }, err => {
                observer.error(err)
            })
        })
    }

    requestLists(): Observable<any> {
        return this.listsProvider.requestAllLists()
    }

    sendImage(imageData: any): Observable<any> {
        return Observable.create(observer => {
            this.mediaProvider.sendMediaByFile(imageData).subscribe(data => {
                observer.next(data)
                console.log("requestFile sucess", data)
            }, err => {
                observer.error(err.message)
                console.log("requestFile error", err)
            })
        })
    }

    getPersistedUser(){
        return this.userProvider.getUserStoraged()
    }

    sendImageFile(file: File): Observable<any> {
        return Observable.create(observer => {
            this.mediaProvider.sendMediaByFileObj(file).subscribe(data => {
                observer.next(data)
                console.log("requestFile sucess", data)
            }, err => {
                observer.error(err.message)
                console.log("requestFile error", err)
            })
        })
    }

    logout(){
        this.userProvider.logout()
    }
}


// WEBPACK FOOTER //
// ./src/pages/cadastro/cadastro.provider.ts